import React from 'react'
import {
  AlignItems,
  Bold,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  JustifyContent,
  Text,
} from '@gousto-internal/citrus-react'

import { formatPrice } from './orderSummaryPricing'

type ValueBannerProps = {
  averageCostPerRecipe?: string
  averageCostPerPortion?: string
}

const formatPositivePrice = (price?: string) => {
  const priceValue = Number(price)

  if (!Number.isFinite(priceValue) || priceValue <= 0) {
    return null
  }

  return formatPrice(price)
}

export const ValueBanner = ({ averageCostPerRecipe, averageCostPerPortion }: ValueBannerProps) => {
  const formattedRecipeCost = formatPositivePrice(averageCostPerRecipe)
  const formattedPortionCost = formatPositivePrice(averageCostPerPortion)

  if (!formattedRecipeCost || !formattedPortionCost) {
    return null
  }

  return (
    <Box
      data-testid="value-banner"
      bg={Color.Informative_50}
      borderRadius={1.5}
      paddingH={4}
      paddingV={4}
      color={Color.Informative_900}
      style={{ borderRadius: '8px' }}
    >
      <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={1}>
        <Box
          display={Display.Flex}
          justifyContent={JustifyContent.SpaceBetween}
          alignItems={AlignItems.FlexStart}
          gap={3}
        >
          <Text size={3} fontWeight={FontWeight.Bold}>
            Average cost per recipe
          </Text>
          <Text size={3} fontWeight={FontWeight.Bold} style={{ flexShrink: 0 }}>
            {formattedRecipeCost}
          </Text>
        </Box>
        <Text size={2}>
          Only <Bold>{formattedPortionCost}</Bold> per portion for your box
        </Text>
      </Box>
    </Box>
  )
}
